import { GoogleAuthProvider, signInWithPopup } from "@firebase/auth";
import { FaGooglePlusG } from 'react-icons/fa';
// import { toast, ToastContainer } from "react-toastify";
import { postData } from "../api";
import { EmailLoginUrl, GoogleLoginUrl, ResetPasswordUrl, ResendVerifyCodeUrl } from "../constants/endPoints";
import { auth } from "../constants/FirebaseConstraints";
// import useVechaiuiNotification from "../Hooks/useVechaiuiNotification";
import { Modal, notification } from "antd";
import useLocalStorage from "../Hooks/useLocalStorage";
import { useHistory } from "react-router";
import { useState } from "react";
import { Link } from "react-router-dom";
import SEO from "../Components/SEO";
import AppLoader from "./Components/AppLoader";
import VerifyCodeModal from "./Components/VerifyCodeModal";
import { getPendingVerification, clearPendingVerification } from "../constants/pendingVerification";
// import 'firebaseu'
// const auth = getAuth();
// const provider = new GoogleAuthProvider();
// provider.setCustomParameters({ prompt: 'select_account' });
// const [user,setUser] = u
const Login = () => {
    const googleAuthProvider = new GoogleAuthProvider();
    const [user, setUser] = useLocalStorage("user");
    const history = useHistory();
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isGoogleLoading, setIsGoogleLoading] = useState(false);
    const [isForgotOpen, setForgotOpen] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [isResetting, setIsResetting] = useState(false);
    const [verifyState, setVerifyState] = useState({ visible: false, userId: null, email: "" });
    const showForgotModal = () => {
        setForgotEmail(email || "");
        setForgotOpen(true);
    }
    const hideForgotModal = () => {
        setForgotOpen(false);
    }
    const sendResetEmail = async () => {
        if (!forgotEmail || forgotEmail.indexOf('@') < 1) {
            notification.error({
                message: "Error",
                description: "Por favor insira um endereço de email válido"
            });
            return;
        }
        setIsResetting(true);
        let response = await postData(ResetPasswordUrl, { user_email: forgotEmail }, true);
        setIsResetting(false);
        if (response && response.data && response.data.status === 'success') {
            notification.success({
                message: "Sucesso",
                description: "Verifique o seu email para redefinir a senha."
            });
            hideForgotModal();
            setForgotEmail("");
        }
    }
    const signInWithGoogle = () => {
        setIsGoogleLoading(true);
        signInWithPopup(auth, googleAuthProvider).then(async (res) => {
            console.log(res)
            if (!res.user) {
                setIsGoogleLoading(false);
                return;
            }
            try {
                let data = {
                    google_id: res.user.uid,
                    user_name: res.user.displayName,
                    user_email: res.user.email,
                    profile_photo_url: res.user.photoURL,
                };
                console.log(data);
                let response = await postData(GoogleLoginUrl, data);
                if (response.data.user_id) {
                    setUser(response.data);
                    notification.success({
                        message: "Success",
                        description: "Successfully Logged In"
                    });
                    history.push('/');
                    return;
                }
                // notificationHandler("Success","Logged In Successfully",'success');
                // messageHandler("Logged In Successfully",'success');
                console.log(response);
                setIsGoogleLoading(false);
            } catch (e) {
                console.log(e);
                setIsGoogleLoading(false);
            }
        }).catch(e => {
            console.log(e)
            setIsGoogleLoading(false);
        });
    }

    const loginUser = async () => {
        try {
            if (email.length < 1) {
                notification.error({
                    message: "Error",
                    description: "Please enter valid email address"
                });
                return;
            }

            const data = {
                user_email: email,
                user_password: password,
                device_token: "Web"
            }
            setIsLoading(true);
            let response = await postData(EmailLoginUrl, data);
            setIsLoading(false);
            // console.log("login response: ", response);

            if (!response.data) {
                // A locally-remembered signup that never got verified is the one
                // case the backend's generic "account not found" error actually
                // means "verify your email" — everything else (wrong password,
                // truly no account) still shows the plain error.
                const pending = getPendingVerification();
                if (pending && pending.email === email) {
                    const resent = await postData(ResendVerifyCodeUrl, { user_email: email }, true);
                    if (resent && resent.data && resent.data.status === "success") {
                        setVerifyState({ visible: true, userId: pending.userId, email });
                        notification.info({
                            message: "Verifique o seu email",
                            description: "A sua conta ainda não foi verificada. Enviámos um novo código para o seu email."
                        });
                        return;
                    }
                    // The resend itself failed (account meanwhile verified elsewhere,
                    // deleted, etc.) — the stale local record is no longer useful.
                    clearPendingVerification();
                }
                notification.error({
                    message: "Error",
                    description: "No account exist"
                });
                return
            }
            if (response.data.user_id) {
                setUser(response.data);
                notification.success({
                    message: "Success",
                    description: "Successfully Logged In"
                });
                history.push('/');
            } else {
            }
        } catch (e) {
            console.log("login error: ", e);
        }

    }

    const onVerified = (userData) => {
        clearPendingVerification();
        setVerifyState({ visible: false, userId: null, email: "" });
        setUser(userData);
        notification.success({
            message: "Conta verificada",
            description: "A sua conta foi ativada."
        });
        history.push('/');
    }

    return (
        <div className="login-page">
            <SEO title="Login | InfoMotores" description="Entre na sua conta InfoMotores para comprar, vender ou alugar carros, motas, barcos e máquinas em Angola." noindex />
            {isGoogleLoading && <AppLoader />}
            <VerifyCodeModal
                visible={verifyState.visible}
                userId={verifyState.userId}
                email={verifyState.email}
                onVerified={onVerified}
                onCancel={() => setVerifyState({ ...verifyState, visible: false })}
            />
            <div className="login-page-container">
                <Modal
                    visible={isForgotOpen}
                    onCancel={hideForgotModal}
                    onOk={sendResetEmail}
                    okText="Enviar"
                    cancelText="Cancelar"
                    confirmLoading={isResetting}
                    title="Recuperar senha"
                >
                    <form onSubmit={(e) => { e.preventDefault(); }} className="mt-2">
                        <label htmlFor="forgot-email">Insira o seu email e enviaremos um link para redefinir a senha.</label>
                        <input
                            type="email"
                            id="forgot-email"
                            className="form-control mt-2"
                            placeholder="seu@email.com"
                            value={forgotEmail}
                            onChange={(e) => setForgotEmail(e.target.value)}
                        />
                    </form>
                </Modal>
                <main>
                    <nav className="auth-nav">
                        <div className="auth-nav-start">
                            <Link to="/" className="auth-nav-brand">
                                <img src="/external_assets/img/app_logo.png" alt="Infomotores" />
                            </Link>
                            <Link to="/" className="auth-nav-link ms-sm-5">Pagina inicial</Link>
                        </div>
                        <Link to="/signup" className="btn btn-outline-danger auth-nav-cta">Criar conta</Link>
                    </nav>
                    <section className="h-100">
                        <div className="container py-5 h-100">
                            <div className="row d-flex align-items-stretch justify-content-center h-100">
                                <div className="col-12 col-md-6 col-lg-6 text-center mb-4 mb-md-0">
                                    <div className="auth-logo-wrap">
                                        <img src="/external_assets/img/auth_banner.png" className="auth-logo" alt="InfoMotores — anuncie a venda ou aluguer de carros, peças, barcos, máquinas e motas" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="auth-form">
                                    <div className="specials auth-heading">
                                        <h2>Login</h2>
                                    </div>
                                    <form>
                                        {/* <!-- Email input --> */}
                                        <div className="form-outline mb-4">
                                            <input
                                                type="email"
                                                id="form1Example13"
                                                className="form-control form-control-lg"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                            <label
                                                className="form-label"
                                                htmlFor="form1Example13"


                                            >Email address</label>
                                        </div>

                                        {/* <!-- Password input --> */}
                                        <div className="form-outline mb-4">
                                            <input
                                                type="password"
                                                id="form1Example23"
                                                className="form-control form-control-lg"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <label className="form-label" htmlFor="form1Example23">Password</label>
                                        </div>

                                        <div className="d-flex justify-content-around align-items-center mb-4">
                                            {/* <!-- Checkbox --> */}
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="form1Example3"
                                                    defaultChecked
                                                />
                                                <label className="form-check-label" htmlFor="form1Example3"> Remember me </label>
                                            </div>
                                            <a href="#" onClick={(e) => { e.preventDefault(); showForgotModal(); }}>Esqueceu a senha?</a>
                                        </div>

                                        {/* <!-- Submit button --> */}
                                        <div className="d-grid">
                                            <button type="button" onClick={loginUser} className="btn btn-primary btn-lg" disabled={isLoading}>
                                                Sign in
                                            </button>
                                        </div>
                                        <div className="pt-3 text-center">
                                            <Link to={'/signup'}>
                                                Don't Have Account Create New.
                                            </Link>
                                        </div>

                                        <div className="divider d-flex align-items-center my-4">
                                            <p className="text-center fw-bold mx-3 mb-0 text-muted">OR</p>
                                        </div>
                                        <div className="d-grid">
                                            <a onClick={isGoogleLoading ? undefined : signInWithGoogle} className="btn btn-danger btn-lg w-100 auth-social-btn" href="#!" role="button" aria-disabled={isGoogleLoading}>
                                                <FaGooglePlusG size={24} /> With Google
                                            </a>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
}

export default Login;